// src/lib/gtag.ts
export const initializeGTag = () => {
  // const script = document.createElement('script');
  // script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  // script.async = true;
  // document.head.appendChild(script);

  // window.dataLayer = window.dataLayer || [];
  // function gtag() { window.dataLayer.push(arguments); }
  // gtag('js', new Date());
  // gtag('config', trackingId);
  // (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  // })(window,document,'script','dataLayer','GTM-W45559HR');
  (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),
        dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'&time='+new Date().getTime();
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-W45559HR');
};  